import { FaTags } from "react-icons/fa";
import { TagsViewMain } from "../Components/TagsViewMain";

export const TagsModule = (DATA_USER_AUTH = null) => {

    return [
        {
            views: "PRIVATE", path: "/tags", component: <TagsViewMain />,
            roles: null, permissions: null, label: "Etiquetas", icon: <FaTags />,
            displayInHeader: false, displayInFooter: false, displayInSidebar: true,
            isBlockedWhenLogged: false
        },

    ]
};
